import { jsx as r } from "react/jsx-runtime";
import { Children as $, useMemo as T, useState as g } from "react";
import { genColorFromText as c } from "./getColorFromText/index.js";
import { TagButton as h, SimpleTag as x } from "./styles.js";
import { useCurrentMode as C } from "../../utils/hooks/useCurrentMode.js";
import { Tooltip as S } from "../Tooltip/Tooltip.js";
const M = ({
  children: o,
  variant: e = "solid",
  color: i,
  size: l = "default",
  fullWidth: s = !1,
  onClick: m,
  className: n
}) => {
  const p = $.toArray(o).join(""), f = C(), a = T(() => i ?? c(p, f === "dark"), [i, p, f]), [t, u] = g(null), d = !!t && t.scrollWidth > t.clientWidth;
  return /* @__PURE__ */ r(S, { tooltip: o, show: d, children: m ? /* @__PURE__ */ r(
    h,
    {
      type: "button",
      $color: a,
      $variant: e,
      $size: l,
      $fullWidth: s,
      onClick: m,
      ref: u,
      className: n,
      children: o
    }
  ) : /* @__PURE__ */ r(
    x,
    {
      $color: a,
      $variant: e,
      $size: l,
      $fullWidth: s,
      ref: u,
      className: n,
      children: o
    }
  ) });
};
export {
  M as Tag
};
//# sourceMappingURL=Tag.js.map
